import { useContext } from 'react';
import { ConfigContext } from '../contexts/ConfigContext';
import { CustomizationProps } from '../types/config';

const useConfig = (): CustomizationProps => useContext(ConfigContext);

export default useConfig;
